export default "__VITE_ASSET__C2Y5S_0$__"